import { FileFormats } from "../../../../../components/FinalForms/libs/data/fileFormatTypes";
import { validationTypes } from "../../../../../components/FinalForms/libs/data/ValidationTypes";
import { FormFieldTypes } from "../../../../../data/formFieldType";

const initState = {
    File: ""
}

const UploadResumeCandidateFields = {
    name: "Upload Resume Candidate",
    initialState: initState,

    section: [
        {
            title: "Profile Section",
            row: {},
            style: {
                sectionStyle: "col-lg-12 col-md-6",
            },
            fields: [
                {
                    id: "File",
                    label: "",
                    Field_Name: "file",
                    fieldType: FormFieldTypes.FILE,
                    dataField: "File",
                    fieldSetting: {
                        placeholder: "Upload Resume Candidate",
                        // allowSpace: true,
                        // isButtonVisible: false,
                        // isShowPreview: false,
                         allowMultipleFiles: false,
                        // isCustomButtonVisible: true,
                        acceptedFileFormats: [
                            FileFormats.PDF,
                            //  FileFormats.DOCX
                        ],
                        // minFileSizeInMB: 1, // Minimum File size in MB
                        // maxFileSizeInMB: 4, // Maximum File size in MB
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-md-12"
                    }
                },


            ],
        }
    ]

};



export default UploadResumeCandidateFields;